/**
 * @generated SignedSource<<8b0d8d0120926503a740c570f8bf4fe5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$data = {
  readonly id: string;
  readonly user: {
    readonly accountStatus: AccountStatus;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef";
};
export type singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$key = {
  readonly " $data"?: singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "59739a86b6a34ae1b3e960c72938c561";

export default node;
